import { lazy } from "react";
import { connect } from "react-redux";
import { getLegalISSS } from "../../../hooks/Legal/ISSS/useFetchISSS";
import { getLegalISSSAll } from "../../../hooks/Legal/ISSS/useFetchISSSAll";
import { postLegalISSS } from "../../../hooks/Legal/ISSS/useFetchSnapshotISSS";
import { putLegalEmployeeISSS } from "../../../hooks/Legal/ISSS/useFetchEmployeeISSS";
import { getLegalObservationCodeISSS } from "../../../hooks/Legal/ISSS/useFetchObservationCodeISSS";
import { getPayrollHistory } from "../../../hooks/Payroll/Histories/useFetchHistoies";

const IGSS = lazy(() => import("./ISSS"));

const mapStateToProps = (state) => {
  return({
  dataISSS: state.legal.igss.getLegalISSS.data,
  isLoading: state.legal.igss.getLegalISSS.loading,
  isError: state.legal.igss.getLegalISSS.error,
  pagination: state.legal.igss.getLegalISSS.pagination,
  
  dataISSSAll: state.legal.igss.getLegalISSSAll.data,
  isLoadingAll: state.legal.igss.getLegalISSSAll.loading,
  isErrorAll: state.legal.igss.getLegalISSSAll.error,

  snapshotIgssData: state.legal.igss.postLegalSnapshotISSS.data,
  snapshotIgssSuccess: state.legal.igss.postLegalSnapshotISSS.success,
  snapshotIgssLoading: state.legal.igss.postLegalSnapshotISSS.loading,
  snapshotIgssError: state.legal.igss.postLegalSnapshotISSS.error,

  dataCodes: state.legal.igss.getLegalObservationISSS.data,
  isLoadingCodes: state.legal.igss.getLegalObservationISSS.loading,
  isErrorCodes: state.legal.igss.getLegalObservationISSS.error,

  isLoadingPut: state.legal.igss.putLegalEmployeeISSS.loading,
  isErrorPut: state.legal.igss.putLegalEmployeeISSS.error,

  payrolls: state.payroll.payrolls.data,
  periods: state.payroll.histories.data,
  periodsLoading: state.payroll.histories.loading,
})};

const mapDispatchToProps = dispatch => ({
  getLegalISSS: (formData) => dispatch(getLegalISSS(formData)),
  getLegalISSSAll: (formData) => dispatch(getLegalISSSAll(formData)),
  postLegalISSS: (formData) => dispatch(postLegalISSS(formData)),
  putLegalEmployeeISSS: (formData) => dispatch(putLegalEmployeeISSS(formData)),
  getLegalObservationCodeISSS: (formData) => dispatch(getLegalObservationCodeISSS(formData)),
  getPayrollHistory: (formData) => dispatch(getPayrollHistory(formData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IGSS);
